// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%27100%27 height=%27100%27 viewBox=%270 0 100 100%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z%27 fill=%27%23dcca98%27 fill-opacity=%270.05%27 fill-rule=%27evenodd%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Presentation Generator Specific Styles */
.pg-container {
  display: flex;
  flex-direction: column;
  background: linear-gradient(to bottom, #e8ddbc 0%, #f4ead5 100%);
  border-radius: 12px;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  padding: 0;
  position: relative;
  overflow: hidden;
  max-width: 1200px;
  margin: 20px auto;
}

/* Header styles */
.pg-header {
  background: linear-gradient(135deg, #114040 0%, #195959 100%);
  padding: 30px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  border-radius: 12px 12px 0 0;
  position: relative;
}

.pg-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 6px;
  background: linear-gradient(90deg, #dcca98, transparent, #dcca98);
}

.pg-title {
  color: #dcca98;
  font-size: 2.6rem;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  margin: 0;
  letter-spacing: 1px;
}

.pg-logo {
  width: 80px;
  height: 80px;
  object-fit: contain;
  filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.2));
}

/* Form container */
.pg-form {
  padding: 40px;
  background-color: #f9f5e7;
  border-radius: 0 0 12px 12px;
  position: relative;
}

.pg-form::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  opacity: 0.5;
  z-index: 0;
  border-radius: 0 0 12px 12px;
}

/* Input fields styling */
.pg-input-group {
  margin-bottom: 25px;
  position: relative;
  z-index: 1;
}

.pg-input-label {
  display: flex;
  align-items: center;
  font-size: 1.1rem;
  font-weight: 600;
  color: #114040;
  margin-bottom: 10px;
}

.pg-input-label svg {
  margin-right: 8px;
  color: #114040;
}

.pg-input-container {
  position: relative;
}

.pg-input {
  width: 100%;
  padding: 14px 16px;
  border: 2px solid #dcca98;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.8);
  font-size: 1rem;
  color: #333;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.pg-input:focus {
  border-color: #114040;
  background-color: #fff;
  box-shadow: 0 4px 10px rgba(20, 64, 64, 0.1);
  outline: none;
}

.pg-input::placeholder {
  color: #999;
  font-style: italic;
}

.pg-textarea {
  min-height: 120px;
  resize: vertical;
}

.pg-file-upload {
  position: absolute;
  right: 12px;
  top: 80%;
  transform: translateY(-50%);
  background-color: transparent;
  border: none;
  color: #114040;
  font-size: 1.2rem;
  cursor: pointer;
  padding: 8px;
  transition: all 0.3s ease;
  border-radius: 50%;
}

.pg-file-upload:hover {
  background-color: rgba(220, 202, 152, 0.2);
  color: #114040;
}

/* Generate button */
.pg-generate-btn {
  background: linear-gradient(135deg, #114040 0%, #195959 100%);
  color: #dcca98;
  font-size: 1.1rem;
  font-weight: 600;
  padding: 14px 28px;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  display: block;
  margin: 30px auto 10px;
  transition: all 0.3s ease;
  box-shadow: 0 5px 15px rgba(20, 64, 64, 0.3);
  position: relative;
  overflow: hidden;
}

.pg-generate-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(220, 202, 152, 0.2) 0%, transparent 50%, rgba(220, 202, 152, 0.2) 100%);
  transform: translateX(-100%);
  transition: transform 0.6s ease;
}

.pg-generate-btn:hover {
  box-shadow: 0 7px 20px rgba(20, 64, 64, 0.4);
  transform: translateY(-2px);
}

.pg-generate-btn:hover::before {
  transform: translateX(100%);
}

.pg-generate-btn:active {
  transform: translateY(0);
  box-shadow: 0 3px 10px rgba(20, 64, 64, 0.3);
}

.pg-generate-btn:disabled {
  background: #ccc;
  color: #666;
  cursor: not-allowed;
  box-shadow: none;
}

/* Loading indicator */
.pg-loading {
  display: inline-block;
  margin-right: 8px;
  animation: spin 1.5s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Export button and dropdown */
.pg-export-container {
  position: relative;
  margin: 20px auto;
  z-index: 10;
  text-align: center;
}

.pg-export-btn {
  background: linear-gradient(135deg, #dcca98 0%, #c9b785 100%);
  color: #114040;
  font-size: 1.1rem;
  font-weight: 600;
  padding: 12px 24px;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 8px;
}

.pg-export-btn:hover {
  background: linear-gradient(135deg, #c9b785 0%, #b6a674 100%);
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);
}

/* Dropup menu styles */
.pg-dropdown {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: calc(100% + 10px); /* Position above the button */
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 -5px 20px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  width: 280px;
  z-index: 1000;
  animation: slideUp 0.2s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translate(-50%, 10px);
  }
  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}

.pg-dropdown::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid white;
}

.pg-dropdown-option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 18px;
  background: none;
  border: none;
  width: 100%;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.2s ease;
  color: #333;
  font-size: 1rem;
  border-bottom: 1px solid #f0f0f0;
}

.pg-dropdown-option:last-child {
  border-bottom: none;
}

.pg-dropdown-option:hover {
  background-color: #f8f4e6;
}

.pg-dropdown-option svg {
  color: #114040;
  font-size: 1.1rem;
}

/* Slides container styling */
.pg-slides-container {
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin-top: 40px;
}

.pg-slide {
  background: white;
  border-radius: 10px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.pg-slide:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
}

.pg-slide-header {
  background: linear-gradient(135deg, #114040 0%, #195959 100%);
  color: #dcca98;
  padding: 20px;
  text-align: center;
}

.pg-slide-title {
  margin: 0;
  color: #dcca98;
  font-size: 1.6rem;
  font-weight: 600;
}

.pg-slide-content {
  padding: 25px;
}

.pg-slide-text {
  color: #333;
  line-height: 1.6;
  font-size: 1.05rem;
}

.pg-bullet-list {
  list-style-type: none;
  padding: 0;
}

.pg-bullet-item {
  padding-left: 24px;
  position: relative;
  margin-bottom: 10px;
  line-height: 1.5;
}

.pg-bullet-item::before {
  content: '•';
  color: #114040;
  font-size: 1.4rem;
  position: absolute;
  left: 0;
  top: -4px;
}

/* Responsive styles */
@media (max-width: 991px) {
  .pg-container {
    margin: 15px 10px;
  }
  
  .pg-header {
    padding: 25px 15px;
  }
  
  .pg-title {
    font-size: 2.2rem;
  }
  
  .pg-logo {
    width: 70px;
    height: 70px;
  }
  
  .pg-form {
    padding: 30px 20px;
  }
}

@media (max-width: 768px) {
  .pg-header {
    flex-direction: column;
    padding: 20px 15px;
  }
  
  .pg-title {
    font-size: 2rem;
    text-align: center;
  }
  
  .pg-input-group {
    margin-bottom: 20px;
  }
  
  .pg-input {
    padding: 12px 14px;
  }
  
  .pg-generate-btn {
    width: 100%;
    padding: 12px 20px;
  }
  
  .pg-export-container {
    width: 100%;
  }
  
  .pg-export-btn {
    width: 100%;
  }
  
  .pg-dropdown {
    width: 90%;
    max-width: 280px;
  }
}

@media (max-width: 480px) {
  .pg-title {
    font-size: 1.8rem;
  }
  
  .pg-logo {
    width: 60px;
    height: 60px;
  }
  
  .pg-form {
    padding: 20px 15px;
  }
  
  .pg-input-label {
    font-size: 1rem;
  }
  
  .pg-generate-btn {
    font-size: 1rem;
    padding: 10px 16px;
  }
  
  .pg-slide-title {
    font-size: 1.4rem;
  }
  
  .pg-slide-content {
    padding: 15px;
  }
  
  .pg-bullet-item {
    padding-left: 20px;
  }
} `, "",{"version":3,"sources":["webpack://./src/SlideGenerator/PresentationGenerator.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;EACE,aAAa;EACb,sBAAsB;EACtB,gEAAgE;EAChE,mBAAmB;EACnB,0CAA0C;EAC1C,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,6DAA6D;EAC7D,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,iEAAiE;AACnE;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;EACzC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yDAAuuC;EACvuC,YAAY;EACZ,UAAU;EACV,4BAA4B;AAC9B;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,4CAA4C;EAC5C,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,6BAA6B;EAC7B,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,6DAA6D;EAC7D,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gHAAgH;EAChH,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,6DAA6D;EAC7D,0CAA0C;AAC5C;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,yBAAyB,EAAE,8BAA8B;EACzD,uBAAuB;EACvB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,gCAAgC;EAClC;EACA;IACE,UAAU;IACV,6BAA6B;EAC/B;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,WAAW;EACX,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,OAAO;EACP,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* Presentation Generator Specific Styles */\n.pg-container {\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(to bottom, #e8ddbc 0%, #f4ead5 100%);\n  border-radius: 12px;\n  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);\n  padding: 0;\n  position: relative;\n  overflow: hidden;\n  max-width: 1200px;\n  margin: 20px auto;\n}\n\n/* Header styles */\n.pg-header {\n  background: linear-gradient(135deg, #114040 0%, #195959 100%);\n  padding: 30px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  border-radius: 12px 12px 0 0;\n  position: relative;\n}\n\n.pg-header::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 6px;\n  background: linear-gradient(90deg, #dcca98, transparent, #dcca98);\n}\n\n.pg-title {\n  color: #dcca98;\n  font-size: 2.6rem;\n  font-weight: 700;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  margin: 0;\n  letter-spacing: 1px;\n}\n\n.pg-logo {\n  width: 80px;\n  height: 80px;\n  object-fit: contain;\n  filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.2));\n}\n\n/* Form container */\n.pg-form {\n  padding: 40px;\n  background-color: #f9f5e7;\n  border-radius: 0 0 12px 12px;\n  position: relative;\n}\n\n.pg-form::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%23dcca98' fill-opacity='0.05' fill-rule='evenodd'/%3E%3C/svg%3E\");\n  opacity: 0.5;\n  z-index: 0;\n  border-radius: 0 0 12px 12px;\n}\n\n/* Input fields styling */\n.pg-input-group {\n  margin-bottom: 25px;\n  position: relative;\n  z-index: 1;\n}\n\n.pg-input-label {\n  display: flex;\n  align-items: center;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #114040;\n  margin-bottom: 10px;\n}\n\n.pg-input-label svg {\n  margin-right: 8px;\n  color: #114040;\n}\n\n.pg-input-container {\n  position: relative;\n}\n\n.pg-input {\n  width: 100%;\n  padding: 14px 16px;\n  border: 2px solid #dcca98;\n  border-radius: 8px;\n  background-color: rgba(255, 255, 255, 0.8);\n  font-size: 1rem;\n  color: #333;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n}\n\n.pg-input:focus {\n  border-color: #114040;\n  background-color: #fff;\n  box-shadow: 0 4px 10px rgba(20, 64, 64, 0.1);\n  outline: none;\n}\n\n.pg-input::placeholder {\n  color: #999;\n  font-style: italic;\n}\n\n.pg-textarea {\n  min-height: 120px;\n  resize: vertical;\n}\n\n.pg-file-upload {\n  position: absolute;\n  right: 12px;\n  top: 80%;\n  transform: translateY(-50%);\n  background-color: transparent;\n  border: none;\n  color: #114040;\n  font-size: 1.2rem;\n  cursor: pointer;\n  padding: 8px;\n  transition: all 0.3s ease;\n  border-radius: 50%;\n}\n\n.pg-file-upload:hover {\n  background-color: rgba(220, 202, 152, 0.2);\n  color: #114040;\n}\n\n/* Generate button */\n.pg-generate-btn {\n  background: linear-gradient(135deg, #114040 0%, #195959 100%);\n  color: #dcca98;\n  font-size: 1.1rem;\n  font-weight: 600;\n  padding: 14px 28px;\n  border: none;\n  border-radius: 30px;\n  cursor: pointer;\n  display: block;\n  margin: 30px auto 10px;\n  transition: all 0.3s ease;\n  box-shadow: 0 5px 15px rgba(20, 64, 64, 0.3);\n  position: relative;\n  overflow: hidden;\n}\n\n.pg-generate-btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(135deg, rgba(220, 202, 152, 0.2) 0%, transparent 50%, rgba(220, 202, 152, 0.2) 100%);\n  transform: translateX(-100%);\n  transition: transform 0.6s ease;\n}\n\n.pg-generate-btn:hover {\n  box-shadow: 0 7px 20px rgba(20, 64, 64, 0.4);\n  transform: translateY(-2px);\n}\n\n.pg-generate-btn:hover::before {\n  transform: translateX(100%);\n}\n\n.pg-generate-btn:active {\n  transform: translateY(0);\n  box-shadow: 0 3px 10px rgba(20, 64, 64, 0.3);\n}\n\n.pg-generate-btn:disabled {\n  background: #ccc;\n  color: #666;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n/* Loading indicator */\n.pg-loading {\n  display: inline-block;\n  margin-right: 8px;\n  animation: spin 1.5s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Export button and dropdown */\n.pg-export-container {\n  position: relative;\n  margin: 20px auto;\n  z-index: 10;\n  text-align: center;\n}\n\n.pg-export-btn {\n  background: linear-gradient(135deg, #dcca98 0%, #c9b785 100%);\n  color: #114040;\n  font-size: 1.1rem;\n  font-weight: 600;\n  padding: 12px 24px;\n  border: none;\n  border-radius: 30px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pg-export-btn:hover {\n  background: linear-gradient(135deg, #c9b785 0%, #b6a674 100%);\n  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);\n}\n\n/* Dropup menu styles */\n.pg-dropdown {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  bottom: calc(100% + 10px); /* Position above the button */\n  background-color: white;\n  border-radius: 10px;\n  box-shadow: 0 -5px 20px rgba(0, 0, 0, 0.15);\n  overflow: hidden;\n  width: 280px;\n  z-index: 1000;\n  animation: slideUp 0.2s ease-out;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translate(-50%, 10px);\n  }\n  to {\n    opacity: 1;\n    transform: translate(-50%, 0);\n  }\n}\n\n.pg-dropdown::after {\n  content: '';\n  position: absolute;\n  bottom: -8px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-top: 8px solid white;\n}\n\n.pg-dropdown-option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 18px;\n  background: none;\n  border: none;\n  width: 100%;\n  text-align: left;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  color: #333;\n  font-size: 1rem;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.pg-dropdown-option:last-child {\n  border-bottom: none;\n}\n\n.pg-dropdown-option:hover {\n  background-color: #f8f4e6;\n}\n\n.pg-dropdown-option svg {\n  color: #114040;\n  font-size: 1.1rem;\n}\n\n/* Slides container styling */\n.pg-slides-container {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n  margin-top: 40px;\n}\n\n.pg-slide {\n  background: white;\n  border-radius: 10px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.pg-slide:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);\n}\n\n.pg-slide-header {\n  background: linear-gradient(135deg, #114040 0%, #195959 100%);\n  color: #dcca98;\n  padding: 20px;\n  text-align: center;\n}\n\n.pg-slide-title {\n  margin: 0;\n  color: #dcca98;\n  font-size: 1.6rem;\n  font-weight: 600;\n}\n\n.pg-slide-content {\n  padding: 25px;\n}\n\n.pg-slide-text {\n  color: #333;\n  line-height: 1.6;\n  font-size: 1.05rem;\n}\n\n.pg-bullet-list {\n  list-style-type: none;\n  padding: 0;\n}\n\n.pg-bullet-item {\n  padding-left: 24px;\n  position: relative;\n  margin-bottom: 10px;\n  line-height: 1.5;\n}\n\n.pg-bullet-item::before {\n  content: '•';\n  color: #114040;\n  font-size: 1.4rem;\n  position: absolute;\n  left: 0;\n  top: -4px;\n}\n\n/* Responsive styles */\n@media (max-width: 991px) {\n  .pg-container {\n    margin: 15px 10px;\n  }\n  \n  .pg-header {\n    padding: 25px 15px;\n  }\n  \n  .pg-title {\n    font-size: 2.2rem;\n  }\n  \n  .pg-logo {\n    width: 70px;\n    height: 70px;\n  }\n  \n  .pg-form {\n    padding: 30px 20px;\n  }\n}\n\n@media (max-width: 768px) {\n  .pg-header {\n    flex-direction: column;\n    padding: 20px 15px;\n  }\n  \n  .pg-title {\n    font-size: 2rem;\n    text-align: center;\n  }\n  \n  .pg-input-group {\n    margin-bottom: 20px;\n  }\n  \n  .pg-input {\n    padding: 12px 14px;\n  }\n  \n  .pg-generate-btn {\n    width: 100%;\n    padding: 12px 20px;\n  }\n  \n  .pg-export-container {\n    width: 100%;\n  }\n  \n  .pg-export-btn {\n    width: 100%;\n  }\n  \n  .pg-dropdown {\n    width: 90%;\n    max-width: 280px;\n  }\n}\n\n@media (max-width: 480px) {\n  .pg-title {\n    font-size: 1.8rem;\n  }\n  \n  .pg-logo {\n    width: 60px;\n    height: 60px;\n  }\n  \n  .pg-form {\n    padding: 20px 15px;\n  }\n  \n  .pg-input-label {\n    font-size: 1rem;\n  }\n  \n  .pg-generate-btn {\n    font-size: 1rem;\n    padding: 10px 16px;\n  }\n  \n  .pg-slide-title {\n    font-size: 1.4rem;\n  }\n  \n  .pg-slide-content {\n    padding: 15px;\n  }\n  \n  .pg-bullet-item {\n    padding-left: 20px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
